module.exports = __webpack_public_path__ + "media/images/top/pap/icon/blue/ico_arrow_triangle_right-9431806812e90e35e5388a91784640f0.svg";